import { render, staticRenderFns } from "./OrderAnalisys.vue?vue&type=template&id=184bfb6c&scoped=true"
import script from "./OrderAnalisys.vue?vue&type=script&lang=ts"
export * from "./OrderAnalisys.vue?vue&type=script&lang=ts"
import style0 from "./OrderAnalisys.vue?vue&type=style&index=0&id=184bfb6c&prod&scoped=true&lang=css"
import style1 from "./OrderAnalisys.vue?vue&type=style&index=1&id=184bfb6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184bfb6c",
  null
  
)

export default component.exports